<script setup lang="ts">
  const formatNumber = (num: number) => (num < 10 ? `0${num}` : `${num}`);

  const props = defineProps<{
    title: string;
    to: string;
    amount: number;
    classes: string;
    isLoading: boolean;
    badgeClasses: string;
  }>();
</script>

<template>
  <component
    :is="amount > 0 ? 'router-link' : 'div'"
    :to="amount > 0 ? props.to : undefined"
    class="h-[42px] flex items-center gap-4 px-6 py-2.5 rounded-2xl border-container"
    :class="[classes, { 'opacity-50 cursor-not-allowed': amount <= 0 }]"
  >
    <span class="whitespace-nowrap">{{ props.title }}</span>
    <span
      v-if="isLoading"
      class="px-2 py-0.5 font-medium rounded-full bg-gray-02"
    > ... </span>
    <span
      v-else
      class="px-2 py-0.5 font-medium rounded-full"
      :class="badgeClasses"
    >
      {{ formatNumber(amount as number) }}
    </span>
  </component>
</template>
